(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("calculator", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: {
                renew: "=",
                addNewUsers: "=",
                subscription: "="
            },
            templateUrl: "app/settings/subscription/calculator/calculatorView.html",
            controller: ["subscriptionCheckoutService", "currencyConverterResource", "subscriptionResource", "messageService", "currencyService", "$state", "$translate", CalculatorCtrl],
            controllerAs: "vm"
        };
        function CalculatorCtrl(subscriptionCheckoutService, currencyConverterResource, subscriptionResource, messageService, currencyService, $state, $translate) {
            var vm = this;
            vm.$onInit = function () {
                vm.maxUsersToContactAdmin = 1000;
                vm.numActiveUsers = 0;
                vm.subscription.userCount > 0 ? Math.max(vm.subscription.userCount, vm.subscription.currentActiveUsers) : Math.max(250, vm.subscription.currentActiveUsers);
                vm.calculation = { method: 3 };
                //Calculations are always shown in US$
                var currency = currencyService.find("USD");
                vm.currencies = currencyService.getPayPalList();
                vm.selectedCurrency = currency;
                vm.currencySymbol = currency.symbol;
                vm.currencySymbolNative = currency.symbol_native;
                vm.currencyCode = currency.code;
                vm.currencyName = $translate.instant("common.currency.USD");
            };
            vm.calculateCost = function () {
                if (vm.calculationInput.$valid) {
                    vm.calculating = true;
                    vm.contactSkillBuilder = false;
                    subscriptionResource.calculateSubscriptionCost({ numberOfUsers: vm.numActiveUsers }, function (result) {
                        vm.calculating = false;
                        vm.calculationCompleted = true;
                        //var paymentMethod = vm.calculation.method;
                        vm.calculation = result;
                        vm.calculation.method = 3;
                        vm.calculateTotal();
                    }, function (error) {
                        vm.calculating = false;
                        messageService.error(error);
                    });
                }
                else {
                    vm.showErrors = true;
                }
            };
            vm.currencyChanged = function () {
                vm.conversionComplete = false;
                if (vm.calculation.total && vm.selectedCurrency.code !== "USD") {
                    currencyConverterResource.convert({ from: vm.selectedCurrency.code, to: "USD" }, function (data) {
                        vm.rate = data.value;
                        vm.convertedTotal = vm.calculation.total / vm.rate;
                        vm.convertedMonthlyCost = vm.calculation.monthlyCost / vm.rate;
                        vm.date = new Date();
                        vm.conversionComplete = true;
                    }, function (error) {
                        messageService.error(error);
                    });
                }
            };
            vm.numUsersChanged = function () {
                vm.calculationError = null;
                vm.calculationCompleted = false;
                vm.disableSomeUsers = false;
                if (vm.numActiveUsers < vm.subscription.currentActiveUsers) {
                    vm.disableSomeUsers = true;
                }
            };
            vm.calculateTotal = function () {
                vm.calculation.total = vm.calculation.annualAdminFee + (vm.calculation.annualCost - vm.calculation.annualDiscountAmount);
                vm.currencyChanged();
            };
            vm.checkout = function () {
                subscriptionCheckoutService.start(vm.numActiveUsers, vm.calculation.method, vm.selectedCurrency);
                $state.go("main.settings.subscriptionCheckout.step1");
            };
        }
    });
}());
